// extracted by mini-css-extract-plugin
export default {"imageHeight":"r_0hG4sww6IrQHRYmMRV","pageListContainer":"sR1l2fPrmKgbl8gEekuw","footer":"qSb5qQOpC4kUXY5i8zG9","setCustomHeight":"vR15yA9okDrNBUF_wssV"};